import { Anchor, Checkbox, Text } from '@byecode/ui'
import * as React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import styled from 'styled-components'

interface AuditReadyProps {}

const SCxTitle = styled.div`
    color: var(--color-black);
    font-size: 24px;
    line-height: 32px;
    font-weight: 600;
`

const SCxDescribe = styled.div`
    color: var(--color-gray-400);
    font-size: var(--font-size-normal);
    line-height: 22px;
    margin-top: 8px;
`

const SCxContent = styled.div`
    width: 100%;
    padding: 24px 32px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
`

const SCxSubTitle = styled.div`
    font-weight: 600;
    line-height: 22px;
    font-size: var(--font-size-normal);
`
const SCxBox = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 8px 0;
    margin-top: 16px;
`
const checkboxStyles = {
    inner: {
        margin: '2px 8px 4px 0'
    },
    label: {
        alginItems: 'flex-start'
    }
}
const AuditReady: React.FunctionComponent<AuditReadyProps> = props => {
    const { control } = useFormContext()
    return (
        <SCxContent>
            <SCxTitle>第一步：提审前准备</SCxTitle>
            <SCxDescribe>提交审核前，请您需完善并确认下列信息，确保审核通过率（审核时间约1-7天）</SCxDescribe>
            <SCxBox>
                <SCxSubTitle>
                    在
                    <Anchor target="_blank" to="https://mp.weixin.qq.com/">
                        {' '}
                        微信公众平台（小程序）
                    </Anchor>
                    完善以下基本信息：
                </SCxSubTitle>
                <Controller
                    name="hasUploadAvatar"
                    control={control}
                    render={({ field }) => (
                        <Checkbox
                            checked={field.value}
                            styles={checkboxStyles}
                            onChange={e => field.onChange(e.target.checked)}
                            size="xs"
                            label="上传小程序头像"
                        />
                    )}
                />

                <Controller
                    name="hasFilledName"
                    control={control}
                    render={({ field }) => (
                        <Checkbox
                            checked={field.value}
                            styles={checkboxStyles}
                            onChange={e => field.onChange(e.target.checked)}
                            size="xs"
                            label="填写小程序名称"
                        />
                    )}
                />
                <Controller
                    name="hasSelectedCategory"
                    control={control}
                    render={({ field }) => (
                        <Checkbox
                            checked={field.value}
                            styles={checkboxStyles}
                            onChange={e => field.onChange(e.target.checked)}
                            size="xs"
                            label="选择服务类目"
                        />
                    )}
                />
            </SCxBox>

            <SCxBox>
                <SCxSubTitle>小程序功能检查:</SCxSubTitle>
                <Controller
                    name="isFunctionalComplete"
                    control={control}
                    render={({ field }) => (
                        <Checkbox
                            checked={field.value}
                            onChange={e => field.onChange(e.target.checked)}
                            size="xs"
                            style={{
                                alignItems: 'baseline'
                            }}
                            styles={{
                                inner: {
                                    margin: '4px 8px 4px 0'
                                },
                                label: {
                                    alginItems: 'flex-start'
                                }
                            }}
                            label={
                                <Text whiteSpace="pre-wrap" lineHeight="24px">
                                    提交的小程序功能完整，可正常打开和运行，而不是测试版或Demo（如标题、素材不能含'测试'等字样）
                                </Text>
                            }
                        />
                    )}
                />
            </SCxBox>
            <SCxBox>
                <SCxSubTitle>已阅读并了解微信小程序平台审核规则：</SCxSubTitle>
                <Controller
                    name="hasReadSpecification"
                    control={control}
                    render={({ field }) => (
                        <Checkbox
                            checked={field.value}
                            onChange={e => field.onChange(e.target.checked)}
                            size="xs"
                            styles={{
                                inner: {
                                    margin: '3px 8px 4px 0'
                                },
                                label: {
                                    alginItems: 'flex-start'
                                }
                            }}
                            label={
                                <Text lineHeight="22px">
                                    已仔细阅读{' '}
                                    <Anchor target="_blank" to="https://developers.weixin.qq.com/miniprogram/product/index.html">
                                        《微信小程序平台运营规范》
                                    </Anchor>
                                    和
                                    <Anchor target="_blank" to="https://developers.weixin.qq.com/miniprogram/product/reject.html">
                                        《微信小程序平台审核常见被拒绝情形》
                                    </Anchor>
                                </Text>
                            }
                        />
                    )}
                />
            </SCxBox>
        </SCxContent>
    )
}

export default AuditReady
